/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedShippingInfoLink_viewer$ref: FragmentReference;
export type PdpSharedShippingInfoLink_viewer = {|
  +buyerItemConversation?: ?{|
    +serviceId: ?string
  |},
  +onlyTradeRequestsQuote: ?boolean,
  +$refType: PdpSharedShippingInfoLink_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfoLink_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "onlyTradeRequestsQuote",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "useOldPdpShippingModals",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "buyerItemConversation",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId",
              "type": "String!"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId",
              "type": "String!"
            }
          ],
          "concreteType": "Conversation",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ac7b74f337c4adc9b652b0c64c4d1e0f';
module.exports = node;
